'use strict';

var RulesReadonlyController = function RulesReadonlyController($scope, $interval, featureToggleService, whatIfService, constants, validator) {
  var whatIfStatusInterval;
  $scope.readOnlyView = true;
  $scope.whatIfStatus = null;
  $scope.isWhatIfDisabled = false;
  $scope.isWhatIfRequestSubmitted = false;
  $scope.isSubmitDisabled = false;
  $scope.goBackToReadOnlyViewHandler = function () {
    $scope.resetReadOnlyView();
  };
  $scope.showWhatIfResultsHandler = function (event, whatIfStatus) {
    $scope.readOnlyView = false;
    $scope.whatIfStatus = whatIfStatus;
  };
  $scope.resetReadOnlyView = function () {
    $scope.readOnlyView = true;
  };
  $scope.editRule = function () {
    $scope.closePanelHandler();
    if ($scope.rule.subject) {
      $scope.rule.primaryCriteriaLevel = {
        level: $scope.rule.subject.parsedLevel,
        domain: $scope.rule.subject.level,
        fromEdit: true
      };
      $scope.rule.primaryCriteria = $scope.rule.subject.parsedConditions;
    }
    $scope.rule.isEditing = true;
    if ($scope.rule.linkObject) {
      $scope.rule.linkCriteria = $scope.rule.linkObject.parsedConditions;
      $scope.rule.linkCriteriaLevel = {
        domain: $scope.rule.linkObject.level,
        fromEdit: true
      };
      if ($scope.rule.linkCriteriaLevel.domain) {
        $scope.rule.linkCriteriaEnabled = true;
        $scope.rule.linkCriteriaEnabledFromEdit = true;
      }
    }
    $scope.rule.status = {
      domain: $scope.rule.status
    };
    $scope.rule.appliedStrategies = $scope.rule.strategies;
    $scope.$emit('rule:editRule', $scope.rule.isQuickRule, $scope.rule);
  };
  $scope.duplicateRule = function () {
    $scope.$emit('rule-listing:duplicateRule', $scope.rule);
  };
  $scope.$on('rule-listing:triggerWhatIf', function (e, rule, dateFrom, dateTo) {
    updateWhatIfStatus({
      whatIfId: 'TBD',
      status: constants.WHAT_IF_STATUS,
      startDate: dateFrom,
      endDate: dateTo
    });
    whatIfService.triggerWhatIf(rule.carrier, dateFrom, dateTo, rule.technicalId).then(function () {
      $scope.updateWhatIfRequestStatus();
    });
  });
  $scope.$on('whatif:goToShowWhatIfResults', function (e, whatIfStatus) {
    $scope.$broadcast('whatif:showResults', whatIfStatus);
  });
  function updateWhatIfStatus(result) {
    if (result && result.whatIfId) {
      $scope.whatIfStatus = result;
      $scope.isWhatIfRequestSubmitted = true;
      $scope.isWhatIfDisabled = false;
      $scope.isSubmitDisabled = result.globalStatus === constants.WHAT_IF_STATUS.PROCESSING;
    } else {
      $scope.whatIfStatus = null;
      $scope.isWhatIfRequestSubmitted = false;
      $scope.isWhatIfDisabled = result && result.globalStatus === constants.WHAT_IF_STATUS.PROCESSING;
    }
    checkIfWhatIfAnalysisApplicable();
  }
  function checkIfWhatIfAnalysisApplicable() {
    var disableWhatIf = validator.isWhatIfAnalysisDisabled($scope.rule);
    if (disableWhatIf.disabled) {
      $scope.isWhatIfDisabled = disableWhatIf.disabled;
      $scope.isWhatIfDisabledReason = disableWhatIf.reason;
    } else if ($scope.isWhatIfDisabled) {
      $scope.isWhatIfDisabledReason = 'What-if request for a different rule is currently in progress';
    } else {
      $scope.isWhatIfDisabledReason = 'What-if';
    }
  }
  function watchWhatIfRequestStatus() {
    whatIfStatusInterval = $interval(function () {
      whatIfService.getWhatIfStatus($scope.rule).then(function (result) {
        updateWhatIfStatus(result);
        if (result && result.status !== constants.WHAT_IF_STATUS.PROCESSING) {
          cancelWatchingWhatIfStatus();
        }
      });
    }, 5000);
  }
  function cancelWatchingWhatIfStatus() {
    if (whatIfStatusInterval) {
      $interval.cancel(whatIfStatusInterval);
    }
  }
  $scope.updateWhatIfRequestStatus = function () {
    cancelWatchingWhatIfStatus();
    if (featureToggleService.isEnabled('WHAT_IF') && $scope.rule) {
      whatIfService.getWhatIfStatus($scope.rule).then(function (result) {
        updateWhatIfStatus(result);
        if (result && result.status === constants.WHAT_IF_STATUS.PROCESSING) {
          watchWhatIfRequestStatus();
        }
      });
    }
  };
  $scope.$on('$destroy', function () {
    cancelWatchingWhatIfStatus();
  });
  $scope.getWhatIfIconClass = function () {
    if ($scope.whatIfStatus) {
      if ($scope.whatIfStatus.status === constants.WHAT_IF_STATUS.FINISHED) {
        return 'btn-o-green';
      } else if ($scope.whatIfStatus.status === constants.WHAT_IF_STATUS.ERROR) {
        return 'btn-o-red';
      }
    }
    if ($scope.isWhatIfRequestSubmitted) {
      return 'btn-o-blue';
    }
  };
};
RulesReadonlyController.$inject = ['$scope', '$interval', 'FeatureToggleService', 'WhatIfService', 'StrategyConstants', 'CriteriaValidateAndFilterService'];
module.exports = RulesReadonlyController;